<app-s01-navigation></app-s01-navigation>
<main class="voice-search-page" #voiceRef>
  <picture class="lights-bg">
    <source
      srcset="{{ '/assets/images/background/background-dark.webp' | assetpipe }}"
      type="image/webp"
    />
    <source
      srcset="{{ '/assets/images/background/background-dark.jpg' | assetpipe }}"
      type="image/jpeg"
    />
    <img
      alt="Living room lights off"
      class="voice-search-background"
      src="{{ '/assets/images/background/background-dark.jpg' | assetpipe }}"
    />
  </picture>
  <picture class="lights-bg">
    <source
      srcset="{{ '/assets/images/background/background-light.webp' | assetpipe }}"
      type="image/webp"
    />
    <source
      srcset="{{ '/assets/images/background/background-light.jpg' | assetpipe }}"
      type="image/jpeg"
    />
    <img
      alt=""
      data-animation="lights"
      class="voice-search-background dim-ligths"
      src="{{ '/assets/images/background/background-light.jpg' | assetpipe }}"
    />
  </picture>
  <span class="portrait-gradient"></span>

  <app-c01-tv-frame customClass="page-tv-frame">
    <video
      #frontDoorVideo
      playsinline
      autoplay
      loop
      data-animation="front-door"
      class="voice-img"
      src="{{ '/assets/video/front-door.mp4' | assetpipe }}"
      aria-hidden="true"
      aria-live="assertive"
      [title]="videoTitle"
    ></video>
    <picture>
      <source
        srcset="{{ '/assets/images/voice-page/children-shows.webp' | assetpipe }}"
        type="image/webp"
      />
      <source
        srcset="{{ '/assets/images/voice-page/children-shows.jpg' | assetpipe }}"
        type="image/jpeg"
      />
      <img
        data-animation="children-shows"
        alt="showing results for children shows"
        aria-hidden="true"
        aria-live="assertive"
        class="voice-img"
        src="{{ '/assets/images/voice-page/children-shows.jpg' | assetpipe }}"
      />
    </picture>
    <picture>
      <source
        srcset="{{ '/assets/images/voice-page/action-movies.webp' | assetpipe }}"
        type="image/webp"
      />
      <source
        srcset="{{ '/assets/images/voice-page/action-movies.jpg' | assetpipe }}"
        type="image/jpeg"
      />
      <img
        data-animation="action-movies"
        alt="showing results for action Movies"
        aria-hidden="true"
        aria-live="assertive"
        class="voice-img"
        src="{{ '/assets/images/voice-page/action-movies.jpg' | assetpipe }}"
      />
    </picture>

    <div data-animation="intro-screen-wrapper" class="intro-screen-wrapper">
      <app-c09-voice-intro-screen
        (buttonClick)="handleIntroButtonClick($event)"
        [disableIntroButtons]="disableIntroButtons"
        [isListening]="isListening"
        [isLoading]="isLoading"
        [speechResult]="speechResult"
        [isSttEnabled]="isSttEnabled"
        [isModal]="false"
        *ngIf="this.rotationService.isLandscape"
      ></app-c09-voice-intro-screen>
    </div>
  </app-c01-tv-frame>
  <app-c09-voice-intro-screen
    *ngIf="!this.rotationService.isLandscape"
    [isModal]="true"
    (buttonClick)="handleIntroButtonClick($event)"
    [disableIntroButtons]="disableIntroButtons"
    [isListening]="isListening"
    [isLoading]="isLoading"
    [speechResult]="speechResult"
    [isSttEnabled]="isSttEnabled"
  ></app-c09-voice-intro-screen>
  <app-c02-remote-control-buttons
    *ngIf="isSttEnabled"
    [tooltipCopy]="tooltipCopy"
    [buttons]="['voice']"
    [featureName]="featureName"
    [stepIndex]="stepIndex"
  ></app-c02-remote-control-buttons>
  <app-c04-opening-screen [featureName]="featureName"></app-c04-opening-screen>
  <app-c06-end-screen
    [featureName]="featureName"
    [translations]="endScreenTranslations"
    [defaultButtons]="endScreenButtons"
  ></app-c06-end-screen>
  <app-a05-custom-cta></app-a05-custom-cta>
  <app-a03-disclaimer-paragraph [featureName]="featureName"></app-a03-disclaimer-paragraph>
  <app-c03-question-mark-modal [featureName]="featureName"></app-c03-question-mark-modal>
</main>
